// extracted by mini-css-extract-plugin
export default {"noReviews":"reviews_noReviews__YPoZC","reviewsRoot":"reviews_reviewsRoot__pHlU1","review":"reviews_review__Mi39q","author":"reviews_author__999jx","date":"reviews_date__0YJQF"};